import {IntermediatePart} from "../../intermediatePart";
import {ShowerHeadTypes} from "../../constants";

export default class ShowerCommon extends IntermediatePart {

  constructor(props) {
    super(props);
    this.isShowerCommonGroup = true;
  }

  setArmHeadType() { // for feature
    const parent = this.getParent();
    const showerParent = parent.getParent();
    showerParent.setShowerHeadType(ShowerHeadTypes.shower_arm, parent.partId);
    if (showerParent.showerFixture && showerParent.showerFixture.activeFeature && showerParent.showerFixture.activeFeature.metaData["MountType"]
      && !showerParent.showerFixture.activeFeature.metaData["MountType"].includes("0") && !showerParent.showerFixture.disabled) {
      // store.dispatch(setLookOverlayOpened(LOOK_OVERLAYS.notCompatiblePopup));
      // return;
      // this.applyFeatureIfNotCompatible();
      showerParent.showerFixture.disabled = true;
    }
  }

  getArrayOfConditions() {
    const showerParent = this.getParent();
    let conditions = super.getArrayOfConditions(); // roomLayout && roomScene
    const showerSize = showerParent.showerSize();
    if (showerSize) {
      conditions.push({
        propName: "ShowerSize",
        propValue: showerSize
      })
    }
    return conditions
  }

  isActiveFeatureGroup(featureGroupId = "") {
    const showerParent = this.getParent();
    const featureGroup = showerParent[featureGroupId];
    return !!(featureGroup && featureGroup.activeFeature && !featureGroup.disabled)
  }

  togglePosition(position, partId) {
    const showerArm = this.getParent().relatedItems.find(featureGroup => featureGroup.partId === partId);
    if (showerArm && showerArm.layerPositions) {
      if (this.layerPositions[position]) {
        // if (!showerArm.layerPositions[position]) {
        //   showerArm.layerPositions[position] = showerArm.getMatchingPositionFeature(position);
        //   if (showerArm.disabled) {
        //     showerArm.disabled = false;
        //   }
        // }
        // we need always set here in the next line, because we might have another conditions. so update needed
        showerArm.layerPositions[position] = showerArm.getMatchingPositionFeature(position);
        if (showerArm.disabled) {
          showerArm.disabled = false;
        }
      } else {
        showerArm.layerPositions[position] = null;
      }
    }
  }

  checkSameShowerPositionForAnotherFeatureGroup(position) {
    if (this.partId === "shower_head") {
      this.togglePosition(position, "shower_arm");
    } else if (this.partId === "shower_arm") {
      this.togglePosition(position, "shower_head");
    } else if (this.partId === "hand_shower_only") {
      this.togglePosition(position, "hand_shower_holder");
      this.togglePosition(position, "shower_hose");
      this.togglePosition(position, "wall_union");
    } else if (this.partId === "shower_hose") {
      this.togglePosition(position, "hand_shower_holder");
      this.togglePosition(position, "hand_shower_only");
      this.togglePosition(position, "wall_union");
    } else if (this.partId === "hand_shower_holder") {
      this.togglePosition(position, "hand_shower_only");
      this.togglePosition(position, "shower_hose");
      this.togglePosition(position, "wall_union");
    } else if (this.partId === "wall_union") {
      this.togglePosition(position, "hand_shower_only");
      this.togglePosition(position, "shower_hose");
      this.togglePosition(position, "hand_shower_holder");
    }
  }

  showLayerPositionsModal() {
    return true
  }

}
